import NestedForm from "@stimulus-components/rails-nested-form"

export default class extends NestedForm {
  static targets = ['template']

  connect() {
    super.connect()
  }

  disconnect() {
    console.log("Disconnecting")
    super.disconnect()
  }

  // Called inside:
  // /admin/activities/circle_matches
  // /admin/programs/groups - WIP
  // /admin/programs/milestones
  // /user/user_appointments

  // This function is similar to the add() in n_groups_add_controller
  // We're overriding the one provided by NestedForm
  add(event) {
    event.preventDefault()

    // the parent container for `child_index NEW_RECORD` must contain v-pre and .hidden:
    // <table v-pre data-nested-form-target="template" class="hidden">
    const content = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/ig, new Date().getTime().toString())
      .replace(/data-new-record="true"/g, 'data-new-record="true" data-controller="extended-form-controls"')

    this.targetTarget.insertAdjacentHTML("beforebegin", content)

    this.element.dispatchEvent(new CustomEvent("rails-nested-form:add", { bubbles: true }))
  }
}
